/*
 * THE SERIES LIST AND THE SIDEWAYS ROW (2026-10-11), ONE copy for the site, as window.PP_SERIES.
 *
 * Two places show every series in a row that scrolls sideways, and they share this file so they say the same thing:
 *   - the homepage's circles under the search (home-spotlights.js seriesRow; Daniel, 11 Oct: "The circles on the
 *     homepage under the hero, I want those to be series, all the series. If there's not enough room, they should be
 *     scrollable", then "yes circles for pun and story")
 *   - "Other series" at the foot of a series page (rd-series.js; Daniel, 11 Oct: "why have only those? Let's have all
 *     the series and be able to scroll through them left and right")
 *
 * list(items, base): every series in `items`, most designs first (ties A to Z), each with its count, its cover (the
 * series' first card by number: Zodiac starts on Aries) and its page. Two groups that are not series ride with them,
 * counted the same way and linked where the homepage's boxes link: Pun intended (isPun, below: the card list with
 * group=puns) and Storybook classics (the six series in STORYBOOK: the card list with those series). Their covers are
 * the homepage boxes' first picks when those are in the list, else their first design.
 * Each caller reads the live catalogue its own way (the homepage the facts alone, a series page RDF's designs) and
 * hands over one item per design: { id, se (series name as the facts spell it), no (its number), styles, img, n (its
 * name) }, and the Artist Pool when it has it.
 *
 * THE NAME A SHOPPER SEES IS THE SERIES' TITLE (Daniel, 11 Oct: full titles, not the catalogue's short names), the one
 * its series page leads with: The Wonderful Wizard of Oz, not Baum & Denslow. titleFor() is that page's rule, kept here
 * so every place that names a series says the same: the Artist Pool's name (artist-pool.json cards[].sname) for most of
 * the series' cards, matched by card title; none when it is the short name again, or Postcards, Patterns or Zodiac.
 * list() gives each entry `s` (the catalogue's name: links, filters and comparisons) and `t` (what to show: the title,
 * else `s`). Without the Pool, `t` is `s`. loadPool() is the one fetch of the Pool for the page (rd-finding.js uses it).
 *
 * scroller(wrap): the row's behaviour. `wrap` holds a list with data-sc-row and two buttons with data-sc="-1" / "1".
 * It sets more-l / more-r on `wrap` while there is more to see on that side (rd-shell.css .pp-sc: the edge fade and
 * the arrows, which only a mouse gets), and the arrows scroll by most of a screen. Swiping, a trackpad and the keyboard
 * (Tab brings each link into view) are the browser's own.
 *
 * layout/theme.liquid loads this in the head, after rd-calendar.js and before every page's own script; the homepage
 * mock inlines it (venture repo, homepage-spotlights/build.mjs).
 */
(function () {
  'use strict';
  const STORYBOOK = ['Baum & Denslow', 'Barrie & Rackham', 'Rudyard Kipling', 'Edward Lear', 'Conan Doyle & Paget', 'Milne & Shepard', 'Storybook Classics'];   // Storybook Classics: Yonatan's Milne verse cards, 29 Oct 2026
  // as rd-finding.js slug() and canonSeries(): accents fold, & is "and"; Patterns' old "· Birthday" sub-series fold in
  const slug = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/&/g, 'and').replace(/[’'.]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const canon = (raw) => {
    const s = String(raw || '').trim();
    if (!s) return '';
    if (/^patterns with meaning(\s*·.*)?$/i.test(s)) return 'Patterns with Meaning';
    if (/^language of flowers$/i.test(s)) return 'Language of Flowers';
    return s;
  };
  /* PUN INTENDED, THE ONE RULE (2026-10-18). The house pun cards ("I Whale Always Love You", "Olive You": 60 on 18 Oct)
     are the designs the tagger reads as cartoon AND that sit in no series. Until 18 Oct it was "cartoon" alone, which
     was the same 60 until the Old Maps batch (14 Oct) brought Lilian Lancaster's 1868 map caricatures, France and
     Scotland, also read as cartoon, rightly as a style; Daniel, 18 Oct: "France and Scotland found their way into the
     Pun intended series". Every catalogue card but the puns has a series, so "no series" is what marks the house line.
     Used by this file's GROUPS, the card list's ?group=puns (rd-finding.js GET.group) and the series menu's live count
     (series-menu.js). ⚠️ A pun card given a series would leave the group; a new cartoon with no series would join it. */
  const isPun = (styles, se) => (styles || []).includes('cartoon') && !canon(se);
  const enc = encodeURIComponent;
  const HREF = {
    // a page of its own since 2026-10-11 (the real-pages plan, templates/metaobject/series.liquid)
    series: (base, s) => base + '/pages/series/' + enc(slug(s)),
    puns: (base) => base + '/pages/occasions?view=cards&group=puns',   // style=cartoon until 18 Oct (isPun, above)
    storybook: (base) => base + '/pages/occasions?view=cards&series=' + STORYBOOK.map(enc).join(','),
  };
  const GROUPS = [
    { s: 'Pun intended', has: (it) => isPun(it.styles, it.se), href: HREF.puns, cover: 'artist-46a57dd56c6a4b7e' },
    { s: 'Storybook classics', has: (it) => STORYBOOK.includes(canon(it.se)), href: HREF.storybook, cover: 'artist-4e1bd112112f4f96' },   // Off to the Limpopo (Kipling) since 19 Oct; As Good as You Are Beautiful was deleted (rights),
  ];

  // as rd-finding.js pnorm(): how a card title is matched to the Pool's
  const pnorm = (s) => String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[’'"]/g, '').replace(/[^a-z0-9()]+/g, ' ').trim();
  /* The series' title (see the header): `names` are its cards' names, `pool` the Pool's artists. '' when it has none. */
  function titleFor(sn, names, pool) {
    if (!pool || !sn) return '';
    const t = {}, ts = new Set((names || []).map(pnorm));
    pool.forEach((a) => (a.cards || []).forEach((c) => { if (c.sname && ts.has(pnorm(c.title))) t[c.sname] = (t[c.sname] || 0) + 1; }));
    const top = Object.keys(t).sort((a, b) => t[b] - t[a])[0];
    return top && pnorm(top) !== pnorm(sn) && !/postcards|patterns|zodiac/i.test(top) ? top : '';
  }
  const POOL_URL = 'https://artists.picturepops.com/artist-pool.json';
  let poolLoading = null;
  const loadPool = () => poolLoading || (poolLoading = fetch(POOL_URL).then((r) => { if (!r.ok) throw new Error('pool ' + r.status); return r.json(); })
    .then((j) => (Array.isArray(j.artists) ? j.artists : [])).catch((e) => { poolLoading = null; throw e; }));

  function list(items, base, pool) {
    base = base || '';
    const by = {};
    items.forEach((it) => {
      const s = canon(it.se);
      if (!s) return;
      // Patterns with Meaning's numbers counted inside the old sub-series, so they do not order it (rd-finding.js)
      (by[s] = by[s] || []).push({ no: s === 'Patterns with Meaning' ? 999 : parseInt(it.no, 10) || 999, img: it.img, name: it.n });
    });
    const series = Object.keys(by).map((s) => {
      const m = by[s].slice().sort((a, b) => a.no - b.no);
      return { s, t: titleFor(s, m.map((x) => x.name), pool) || s, n: m.length, img: m[0].img, href: HREF.series(base, s) };
    });
    const groups = GROUPS.map((g) => {
      const m = items.filter(g.has);
      if (!m.length) return null;
      const c = m.find((it) => it.id === g.cover) || m[0];
      return { s: g.s, t: g.s, n: m.length, img: c.img, href: g.href(base), group: true };
    }).filter(Boolean);
    return series.concat(groups).sort((a, b) => b.n - a.n || a.s.localeCompare(b.s));
  }

  function scroller(wrap) {
    const row = wrap && wrap.querySelector('[data-sc-row]');
    if (!row) return { hint() {} };
    const hint = () => {
      const x = row.scrollLeft, max = row.scrollWidth - row.clientWidth;
      wrap.classList.toggle('more-l', x > 2);
      wrap.classList.toggle('more-r', x < max - 2);
    };
    row.addEventListener('scroll', hint, { passive: true });
    window.addEventListener('resize', hint);
    wrap.addEventListener('click', (e) => {
      const b = e.target.closest('[data-sc]');
      if (!b || !wrap.contains(b)) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      row.scrollBy({ left: +b.getAttribute('data-sc') * Math.max(160, row.clientWidth * 0.8), behavior: reduce ? 'auto' : 'smooth' });
    });
    hint();
    return { hint };
  }

  window.PP_SERIES = { STORYBOOK, slug, canon, isPun, HREF, list, scroller, titleFor, loadPool, pnorm };
})();
